import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IValidateParentalLockUseCase {
    execute(apiKey: string, identityToken: string, epochMs: string, encLock: string): Promise<any>;
}

export class ValidateParentalLockUseCase implements IValidateParentalLockUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, identityToken: string, epochMs: string, encLock: string): Promise<any> {
        const result = await this.profileRepository.validateParentalLock(apiKey, identityToken, epochMs, encLock);
        return result.data;
    }
}
